import { createContext } from "react"
import type { PluginInstallDto } from "../dtos/marketplace.dto"

export interface PluginInstallsContextValue {
  installs: PluginInstallDto[]
  // Distinct familyIds of active installs — drives the plugin nav items.
  activeFamilies: string[]
  isLoading: boolean
  // True once the current organisation's installs have been fetched, so an empty list can be trusted.
  hasLoaded: boolean
  refresh: () => Promise<void>
}

export const PluginInstallsContext = createContext<PluginInstallsContextValue | null>(null)
